/* When a lock/unlock action button is clicked, make a POST request to the relevant view */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
function LockUnlockAction(csrfToken, next) {
    var actionElements = document.querySelectorAll('[data-locking-action]');
    __spreadArray([], __read(actionElements)).forEach(function (buttonElement) {
        buttonElement.addEventListener('click', function (e) {
            // Stop the button from submitting the form
            e.preventDefault();
            e.stopPropagation();
            var formElement = document.createElement('form');
            formElement.action = buttonElement.dataset.lockingAction;
            formElement.method = 'POST';
            var csrftokenElement = document.createElement('input');
            csrftokenElement.type = 'hidden';
            csrftokenElement.name = 'csrfmiddlewaretoken';
            csrftokenElement.value = csrfToken;
            formElement.appendChild(csrftokenElement);
            if (typeof next !== 'undefined') {
                var nextElement = document.createElement('input');
                nextElement.type = 'hidden';
                nextElement.name = 'next';
                nextElement.value = next;
                formElement.appendChild(nextElement);
            }
            document.body.appendChild(formElement);
            formElement.submit();
        }, { capture: true });
    });
}
window.LockUnlockAction = LockUnlockAction;
